<template>
  <div class="container mt-4">
    <TopNav>
      <NavItem
        icon="far fa-save"
        :text="$t('GENERAL.BUTTON.SAVE')"
        :loading="inProgress"
        @click="saveEvent()"
      />
    </TopNav>
    <div class="content mt-4" v-if="eventLoaded">
      <h1 class="mt-4 mb-4">{{ $t('EVENTS.TITLE.DUPLICATE_EVENT') }}</h1>
      <ValidationObserver ref="form">
        <EventForm :localEvent="duplicatedEvent" />
      </ValidationObserver>
      <div class="my-5"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TopNav from '@/web/components/navigation/TopNav';
import { errorToMessage, scrollToFirstFormError } from '@/core/utils/errors';
import EventForm from '@/web/components/events/EventForm';
import NavItem from '@/web/components/navigation/NavItem';
import { ValidationObserver } from 'vee-validate';
import HMDialog from '@/web/components/common/HMDialog.vue';

export default {
  name: 'DuplicateEvent',
  components: {
    TopNav,
    NavItem,
    EventForm,
    ValidationObserver,
  },
  computed: {
    ...mapGetters({
      event: 'event/event',
    }),
  },
  data() {
    return {
      eventLoaded: false,
      duplicatedEvent: null,
      inProgress: false,
    };
  },
  methods: {
    async saveEvent() {
      if (this.inProgress) {
        return;
      }
      console.log('Updating event:', this.duplicatedEvent);
      this.$refs.form.validate();
      if (this.$refs.form.flags.invalid) {
        scrollToFirstFormError();
        return;
      }
      this.inProgress = true;
      try {
        await this.$store.dispatch('event/createEvent', this.duplicatedEvent);
        this.onSave();
      } catch (error) {
        console.log(error);
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to save the event',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
    async onSave() {
      if (this.event.is_www_event) {
        this.$modal.show(HMDialog, {
          title: this.$t('EVENTS.TITLE.POST_ON_WELLWELLWELL'),
          htmlContent: this.$t('EVENTS.TEXT.POST_ON_WELLWELLWELL_DESCRIPTION'),
          confirmButton: this.$t('EVENTS.BUTTON.VIEW_YOUR_LISTING'),
          discardButton: this.$t('EVENTS.BUTTON.BACK_TO_CALENDAR'),
          confirm: () => {
            const url = `${process.env.VUE_APP_WELLWELLWELL_BASE_URL}/events/${this.event.id}`;
            window.open(url);
            this.$router.replace({ name: 'events-calendar' });
          },
          discard: () => {
            this.$router.replace({ name: 'events-calendar' });
          },
        });
      } else {
        this.$router.replace({ name: 'events-calendar' });
      }
    },
  },
  async mounted() {
    try {
      const event = await this.$store.dispatch(
        'event/getEventDetails',
        this.$route.params.id
      );
      this.duplicatedEvent = {
        ...event,
        event_name: `Copy of ${event.event_name}`,
        id: null,
        is_cancelled: false,
        is_repeating_event: false,
        event_template: null,
        event_schedule: null,
        days_of_week: {},
        zoom_meeting_id: null,
        zoom_meeting_internal_id: null,
        zoom_start_url: null,
        zoom_join_url: null,
        zoom_meeting_started: false,
      };
      console.log('duplicatedEvent=', this.duplicatedEvent);
      this.eventLoaded = true;
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Failed to load event details',
        text: errorToMessage(error.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    }
  },
};
</script>

<style lang="scss"></style>
